import { render, staticRenderFns } from "./DeparturesTable.vue?vue&type=template&id=c646abf8&scoped=true&"
import script from "./DeparturesTable.vue?vue&type=script&lang=js&"
export * from "./DeparturesTable.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesTable.vue?vue&type=style&index=0&id=c646abf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c646abf8",
  null
  
)

export default component.exports